import { memo } from 'react';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextHeadline, TextLabel2, TextTitle3 } from '@cbhq/cds-web/typography';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import SummaryCard from './SummaryCard';

type RewardsCardProps = {
  hasUsdcRewards: boolean;
  rewardRate: number;
};

const RewardsCard = memo(function RewardsCard({ hasUsdcRewards, rewardRate }: RewardsCardProps) {
  if (!hasUsdcRewards) return null;

  const header = (
    <HStack justifyContent="space-between" alignItems="center" width="100%">
      <TextTitle3 as="h2" testID="rewards-card-title">
        USDC rewards
      </TextTitle3>
      <HStack
        background="bgSecondary"
        paddingX={1.5}
        paddingY={0.5}
        borderRadius={1000}
        gap={1}
        alignItems="center"
      >
        <VStack width={12} height={12} borderRadius={1000} background="bgPositive" />
        <TextHeadline as="span">Earning</TextHeadline>
      </HStack>
    </HStack>
  );

  return (
    <SummaryCard header={header}>
      <VStack paddingX={3} paddingBottom={1.5}>
        <TextLabel2 as="p" color="fgMuted">
          You&apos;re earning back {rewardRate}% on all USDC invested.{' '}
          <TextLabel2 as="span" color="fgPrimary" style={{ cursor: 'pointer' }}>
            Learn more
          </TextLabel2>
        </TextLabel2>
      </VStack>
      <ListCell compact title="Reward rate" detail={`${rewardRate}%`} />
    </SummaryCard>
  );
});

export default RewardsCard;
